import { AssistantsEndpoints, assistantsFetchJson } from './assistantsApiClient';

/**
 * @param {{ agentSlug: string, scopeType?: string }} params
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function getReferenceUrlScopes({ agentSlug, scopeType = 'state' }) {
  const params = new URLSearchParams({ agent_slug: agentSlug, scope_type: scopeType });
  const data = await assistantsFetchJson(`${AssistantsEndpoints.REFERENCE_URL_SCOPES}?${params.toString()}`);
  return data.scopes || [];
}
